export const GET_LMOPERATIONHOURS_API_REQUEST = "GET_LMOPERATIONHOURS_API_REQUEST";
export const GET_LMOPERATIONHOURS_API_SUCCESS = "GET_LMOPERATIONHOURS_API_SUCCESS";
export const GET_LMOPERATIONHOURS_API_ERROR = "GET_LMOPERATIONHOURS_API_ERROR";

export const POST_LMOPERATIONHOURS_API_REQUEST = "POST_LMOPERATIONHOURS_API_REQUEST";
export const POST_LMOPERATIONHOURS_API_SUCCESS = "POST_LMOPERATIONHOURS_API_SUCCESS";
export const POST_LMOPERATIONHOURS_API_ERROR = "POST_LMOPERATIONHOURS_API_ERROR";
